"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _classnames = _interopRequireDefault(require("classnames"));

var Yup = _interopRequireWildcard(require("yup"));

var _hover = require("../../hooks/hover");

var _formik = require("formik");

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));

var _Button = _interopRequireDefault(require("../Button"));

var _Input = _interopRequireDefault(require("../Input"));

var BeforeDelete = function BeforeDelete(_ref) {
  var onProceed = _ref.onProceed;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      check = _useState2[0],
      setCheck = _useState2[1];

  var _useHover = (0, _hover.useHover)(),
      hovered = _useHover.hovered,
      targetProps = _useHover.targetProps;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    width: "801",
    height: "480",
    alt: "Delete Account",
    className: "h-48 mx-auto object-contain",
    src: t('delete-account.png')
  }), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl text-dark font-bold"
  }, t('deleteAccount.before.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm px-12 text-gray-light font-semibold mt-3"
  }, t('deleteAccount.before.description')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/_react["default"].createElement("label", (0, _extends2["default"])({
    className: 'cursor-pointer text-sm inline-flex items-center'
  }, targetProps), /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    name: "checkbox",
    className: "hidden",
    onChange: function onChange(e) {
      return setCheck(e.target.checked);
    }
  }), check ? /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], {
    className: "text-primary",
    fontSize: "small"
  }) : /*#__PURE__*/_react["default"].createElement(_CheckBoxOutlineBlank["default"], {
    className: (0, _classnames["default"])('text-gray-light', {
      'opacity-75': !hovered,
      'opacity-50': hovered
    }),
    fontSize: "small"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-gray-light ml-2 font-semibold"
  }, t('deleteAccount.before.checkbox')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "!px-10",
    disabled: !check,
    onClick: onProceed
  }, t('button.next'))));
};

var DeleteConfirm = function DeleteConfirm(_ref2) {
  var email = _ref2.email,
      onClose = _ref2.onClose,
      onConfirm = _ref2.onConfirm,
      isLoading = _ref2.isLoading;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl text-dark font-bold"
  }, t('deleteAccount.confirm.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm text-gray-light font-semibold mt-3"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "deleteAccount.confirm.description"
  }, "This action will permanently delete your account [", {
    email: email
  }, "] and all associated email and other data. This action cannot be undone.", /*#__PURE__*/_react["default"].createElement("br", null), "Type in ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold text-dark"
  }, {
    email: email
  }), " to confirm.")), /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      email: ''
    },
    validationSchema: Yup.object({
      email: Yup.string().oneOf([email]).required()
    }),
    render: function render(_ref3) {
      var dirty = _ref3.dirty,
          errors = _ref3.errors;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
        autoFocus: true,
        name: "email",
        spellCheck: "false",
        autoComplete: "off",
        className: "w-full mt-4 mb-8 font-semibold",
        placeholder: t('deleteAccount.confirm.placeholder')
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "secondary",
        onClick: onClose,
        className: "mr-2 w-32"
      }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "warning",
        disabled: !(0, _isEmpty["default"])(errors) || !dirty || isLoading,
        onClick: onConfirm,
        className: "w-48 flex-shrink-0"
      }, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
        size: 24
      }) : t('button.deleteMyAccount'))));
    }
  }));
};

var View = function View(_ref4) {
  var email = _ref4.email,
      isLoading = _ref4.isLoading,
      onClose = _ref4.onClose,
      onConfirm = _ref4.onConfirm;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showConfirm = _useState4[0],
      setConfirm = _useState4[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-8 pb-8 pt-4 bg-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    className: "text-gray-light hover:opacity-75",
    fontSize: "large"
  }))), showConfirm ? /*#__PURE__*/_react["default"].createElement(DeleteConfirm, {
    email: email,
    isLoading: isLoading,
    onConfirm: onConfirm,
    onClose: onClose
  }) : /*#__PURE__*/_react["default"].createElement(BeforeDelete, {
    onProceed: function onProceed() {
      return setConfirm(true);
    }
  }));
};

View.displayName = 'DeleteAccountConfirm';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=index.js.map